import React, {useContext} from "react";
import {HorizontalSeparator} from "../../separators/Separators";
import LineMeaningComponent from "./LineMeaningComponent";
import HerfindalChart from "../../Charts/HerfindalChart";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import HerfindahlRecord from "../../../models/HerfindahlRecord";
import TwoColumnsLayout from "../../TwoColumnsLayout/TwoColumnsLayout";
import { RegionSelectedContext } from "../../../contexts/RegionSelectedContext";


const HerfindalContainer = styled.div`
  display: flex;
  flex: 1 0 auto;

  @media (max-width: 480px) {
    display: block;
  }
`;

const MarketClusteringContentComponent: React.FC<{openDetails: () => void}> = ({openDetails}) => {
    const { t } = useTranslation();
    const { latamHerfindahlRecords, reaseguroHerfindahlRecords } = useContext(GlobalDataContext);
    const { yearSelected, regionSelected } = useContext(RegionSelectedContext);

    const herfindahlRecords = regionSelected === "latam" ? latamHerfindahlRecords : reaseguroHerfindahlRecords;

    const firstYear = Math.min(...herfindahlRecords.map((x: HerfindahlRecord) => x.year));
    const lastYear = Math.max(...herfindahlRecords.map((x: HerfindahlRecord) => x.year));

    return (
      <TwoColumnsLayout
        leftColumnChildren={
          <>
            <h3 className={'marginTop50'}>
              { t(`latamMarketConcentration.${yearSelected.niiff ? "niif." : ""}paragraphTitle`) }
            </h3>
            <HorizontalSeparator width={50}/>
            <p className={'marketAnalysisText'}>
              {t(regionSelected === "latam" ? 'latamMarketConcentration.paragraph' : 'latamMarketConcentration.re.paragraph')}
            </p>
            <div className='see-more-details' onClick={openDetails}>
              { t('latamMarketConcentration.seeMoreDetails') }
            </div>
          </>
        }
        rightColumnChildren={
          <div className='chart-container' style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <h3 style={{ flex: '0 0 auto' }}>{ t('latamMarketConcentration.subtitle') }</h3>
            <div className={'chartSubTitleMC'} style={{ flex: '0 0 auto' }}>
              { t('latamMarketConcentration.firstChartSubtitle', { yearStart: firstYear, yearEnd: lastYear }) }
            </div>
            <div style={{ flex: '0 0 auto' }}>
              <LineMeaningComponent/>
            </div>
            <HerfindalContainer>
              <HerfindalChart series={herfindahlRecords} customStyle={{ height: '100%' }}/>
            </HerfindalContainer>
          </div>
        }
      />
    )
};

export default MarketClusteringContentComponent;
